import { ArrowUp, ArrowDown, Minus } from "lucide-react";

export function RankBadge({ movement = 0, className = "" }) {
  if (movement > 0) {
    return (
      <span className={`inline-flex items-center gap-1 font-mono-stat text-xs text-rankup ${className}`} data-testid="rank-movement-up">
        <ArrowUp className="w-3.5 h-3.5" /> {movement}
      </span>
    );
  }
  if (movement < 0) {
    return (
      <span className={`inline-flex items-center gap-1 font-mono-stat text-xs text-rankdown ${className}`} data-testid="rank-movement-down">
        <ArrowDown className="w-3.5 h-3.5" /> {Math.abs(movement)}
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 font-mono-stat text-xs text-muted-foreground ${className}`} data-testid="rank-movement-same">
      <Minus className="w-3.5 h-3.5" />
    </span>
  );
}
